module.exports = __webpack_public_path__ + "2b535f152e050f9895d50d8a14f956c4.pdf";